import React from "react";

import { isEmpty } from "lodash/fp";

import { SectionContainer } from "@app/analytics/components/reports/styles";
import {
  EmptyOverviewText,
  OverviewButton,
  OverviewHeading,
} from "@app/analytics/TopicReport/TopicReportSidebar/styles";
import type { Topic } from "@app/analytics/types";
import Config from "@app/config";

import { Row } from "@rui/Stack";

const SharedTopicReportDetails = ({ topic }: { topic?: Topic }) => {
  if (!topic || !Config.flags.enableKeywordsOnSharedTopicReport) return null;

  return (
    <SectionContainer maxWidth="md">
      <Row spacing={2}>
        <Row variant="left" height="34px" spacing={1}>
          <OverviewHeading sx={{ mb: 0 }}>Keywords</OverviewHeading>
        </Row>
        <Row flexWrap="wrap" spacing={1} minHeight="34px" variant="left">
          {isEmpty(topic.keywords) ? (
            <EmptyOverviewText>No keywords</EmptyOverviewText>
          ) : (
            topic.keywords.map((keyword) => (
              <OverviewButton key={keyword}>{keyword}</OverviewButton>
            ))
          )}
        </Row>
      </Row>
    </SectionContainer>
  );
};

export default SharedTopicReportDetails;
